export default {
  PROPERTIES_LIST: "List of transactions",
};
